"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./KeytipData"), exports);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/KeytipData/index.js
// module id = 685
// module chunks = 0